import { TypeInventory } from "~/common/entities/general";
import { ProductInventory } from "~/common/props/orchestrator";

export const availabilityDataCopy = (
  t: (a: string, args?: Record<string, string | number>) => string,
  type: string | undefined,
  inventoryConfig?: ProductInventory,
): string => {
  return type?.toUpperCase() === TypeInventory.Always ||
    type?.toUpperCase() === TypeInventory.Build
    ? t("product.always")
    : type?.toUpperCase() === TypeInventory.Limited
    ? t("product.units", { units: inventoryConfig?.units || "" })
    : "";
};

export const availabilityDataTextCopy = (
  t: (a: string, args?: Record<string, string | number>) => string,
  type: string | undefined,
  inventoryConfig?: ProductInventory,
): string => {
  return type?.toUpperCase() === TypeInventory.Always
    ? t("product.text_always")
    : type?.toUpperCase() === TypeInventory.Limited
    ? t("product.text_limited")
    : type?.toUpperCase() === TypeInventory.Build
    ? t("product.text_to_order", {
        days:
          inventoryConfig?.deliveryDays || inventoryConfig?.delivery_days || 0,
      })
    : "";
};

export const availabilityDataDisplayCopy = (
  t: (a: string, args?: Record<string, string | number>) => string,
  type: string | undefined,
  inventoryConfig?: ProductInventory,
): string => {
  return type?.toUpperCase() === TypeInventory.Always
    ? t("inventory.available_product")
    : type?.toUpperCase() === TypeInventory.Limited ||
      type?.toUpperCase() === TypeInventory.Build
    ? inventoryConfig?.alertFewUnits &&
      inventoryConfig?.units <= inventoryConfig?.alertFewUnits
      ? t("inventory.last_units")
      : inventoryConfig?.units
      ? `"${inventoryConfig.units}" ${t("inventory.units_available")}`
      : ""
    : "";
};
